import { ValidatorFn } from '@angular/forms';
import {
    Component,
    OnInit,
    Inject,
    OnDestroy,
    HostListener,
    ViewChild,
    ChangeDetectorRef
} from '@angular/core';

import {
    FormBuilder,
    FormGroup,
    FormArray,
    AbstractControl,
    Validators
} from '@angular/forms';

import { rules } from '../model/lengthrule';
import { REGISTER } from '../model/register.model';
import 'rxjs/Rx';
import { CurrencyPipe } from '@angular/common';

import {
    Headers,
    Http,
    RequestOptions,
    URLSearchParams,
    Response
} from '@angular/http';
import { POSTTYPE } from '../model/post-type';
import {
    CompleterData,
    CompleterService,
    CompleterItem,
    CompleterCmp
} from 'ng2-completer';

// import * as html2canvas from "html2canvas";
// import * as jsPDF from 'jspdf';
// now change to use pdfmake better for this project
import * as pdfMake from 'pdfmake/build/pdfmake.js';
import * as pdfFonts from 'pdfmake/build/vfs_fonts.js';
import { OUTTYPE } from 'app/model/out-type';
import { ActivatedRoute } from '@angular/router';
import { PDFService } from 'app/services/pdf/pdf.generation';
import { RegisterService } from 'app/services/register/register.service';
import { RetrieveService } from 'app/services/register/retrieve.service';
import { RestrieveCookieService } from 'app/services/register/restrieve.cookie.services';
import { orgTypeToValue } from 'app/model/businessgroup.model';
import { CookieService } from 'ngx-cookie';
import {
    patternValidator,
    reseller_dateValidation
} from 'app/tooltip/validator';
import { createAnimation } from 'app/animations/create.animation';

import datefomart from '../tooltip/dateformater';

declare var require: any;
// import * as jQuery from "jquery";
// declare var $: any;
let $ = require('jquery');

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss']
    // ,animations: [createAnimation],

    // animations: [ERROR_SHOW_ANIMATION]
})
export class RegisterComponent implements OnInit, OnDestroy {
    /**
     * service part
     */
    public dataCountryService: CompleterData;
    public dataPhoneService: CompleterData;
    public countries = require('../tooltip/ngcompleter/countries.json');
    public phones = require('../tooltip/ngcompleter/phone.json');

    public RULES = rules;
    public registerform: FormGroup;
    public registerObj: REGISTER;
    public pdfObj: REGISTER;

    // data modele

    // privacy
    public checkbox_understand = false;
    public checkbox_receiveMail_no = false;
    public checkbox_receiveMail_yes = true;

    // financial
    public checkbox_in_bankrupcyYes = false;
    public checkbox_in_bankrupcyNo = true;

    // pdf data

    // routing
    public sub: any;
    public accountcode = '';

    // layout
    public submitPopUp = false;
    public savePopUp = false;
    public retrievePopUp = false;

    // animation value
    public create = 'initial';

    // FIXED: change the value below to false
    public downloadPDF = false;
    public real_resellerID = '';

    // tmpCompanyCountry : string = this.web() == -1 ? 'Australia' : 'New Zealand';
    // tmpCompanyCity: string = "";

    otherMarketCheck = false;

    public sub_click = false;

    constructor(
        public fb: FormBuilder,
        public completerService: CompleterService,
        public pdfService: PDFService,
        public registerService: RegisterService,
        public retrieveService: RetrieveService,
        public route: ActivatedRoute,
        public retrievecookieService: RestrieveCookieService,
        public cookieService: CookieService,
        public http: Http,
        private cdRef: ChangeDetectorRef
    ) {

        // get completer service ready
        this.dataCountryService = completerService.local(
            this.countries,
            'name',
            'name'
        );

        this.dataPhoneService = completerService
            .local(this.phones, 'code', 'code')
            .descriptionField('name');

        this.registerform = this.fb.group({
            // BUSINESS INFORMATION AREA
            businessGroup: this.buildBusinessGroup(),

            deliverMethodArray: this.fb.array([]),

            businesscontacts: this.buildBusinessContacts(),

            // ownerinformation
            ownerinfoArray: this.fb.array([this.buildOwnerinfoItem()]),

            // one more filed added
            // TODO: register, binding, retrieving,
            marketinfo: this.buildMarketinfo(),

            // business trade ref

            // this.buildBusinessRefItem()
            businessRefArray: this.fb.array([this.buildBusinessRefItem()]),

            // FINANCIAL DETAILS

            financialGroup: this.buildFinancialGroup(),
            //  PRIVACY
            privacyGroup: this.fb.group({
                // [this.checkedAcceptValidator]
                in_read_and_understood: [
                    this.checkbox_understand,
                    [
                        Validators.requiredTrue
                    ]
                ],
                in_mailing_list_no: this.checkbox_receiveMail_no,
                in_mailing_list_yes: this.checkbox_receiveMail_yes,
                in_mailing_email: [
                    '',
                    [
                        Validators.required,
                        Validators.maxLength(this.RULES.in_email),
                        patternValidator(
                            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        )
                    ]
                ]
            }),

            // DECLARATION

            declarationGroup: this.buildDeclarationGroup(),

            // GUARANTEE
            guaranteeGroup: this.buildGuaranteeGroup()
        });
    }

    checkedAcceptValidator = (
        control: AbstractControl
    ): { [key: string]: boolean } => {
        const group = control.value;

        for (const key in group) {
            if (group[key]) {
                return null;
            }
        }

        return { nockecked: true };
    };

    // phonecode: string;
    // @ViewChild("remoteDataExample") private remoteDataExample: CompleterCmp;
    onCountrySelected(selected: CompleterItem) {
        if (selected) {
            console.log(selected);
            // this.registerform.get('businessGroup').formcontrol().patchValue({
            //   phonecode: selected.description
            // });
            // this.registerform.controls["businessGroup"]
            //   .get("in_phonecode")
            //   .setValue(selected.title);
        } else {
            // this.registerform.get('businessGroup').patchValue({
            //   phonecode: ''
            // });
        }
    }

    @HostListener('window:scroll', [])
    onWindowScroll() {
        //  console.log('scroll.....');
        this.onScroll();
    }

    ngOnInit() {
        const today = new Date();
        const currentYear = today.getFullYear();
        const currentMonth = today.getMonth() + 1 >= 10 ? today.getMonth() + 1 : '0' + (today.getMonth() + 1);
        const currentDate = today.getDate() >= 10 ? today.getDate() + 1 : '0' + today.getDate();
        const maxDate = currentYear + "-" + currentMonth + "-" + currentDate

        $('#declarationDate').attr('max', maxDate);       
        // $('#declarationDate').attr('max', '2022-12-08');

        $(document).on('click', 'a[href^="#"]', function (event) {
            event.preventDefault();

            $('html, body').animate(
                {
                    scrollTop: $($.attr(this, 'href')).offset().top
                },
                500
            );
        });

        // $(window).on("scroll", this.onScroll());
        //debugger;
        //console.log("--->date: ",datefomart());
        this.sub = this.route.params.subscribe(params => {
            // console.log("do i come in the subscript of router?");
            this.accountcode = params['id']; // (+) converts string 'id' to a number
            let check: boolean = false;
            // In a real app: dispatch action to load the details here.
            // console.log(this.accountcode, params["id"]);
            //applicationID
            let applicationID = <string>this.cookieService.getObject('applicationID');
            let resumeID = <string>this.cookieService.getObject('resumeID');
            // let testID = this.cookieService.get('retrievecode');
            // debugger;
            // console.log('applicationID',this.cookieService.get('applicationID') )
            if (typeof resumeID != 'undefined' && resumeID != '') {
                this.accountcode = resumeID;
                // debugger;
                this.cookieService.remove('resumeID');
                this.fillForm(this.accountcode);
            }
            //check the first login has applicationID (from backend set)
            if (typeof applicationID != 'undefined' && applicationID != '') {
                //console.log("applicationID: ", applicationID);
                this.accountcode = applicationID;
                // debugger;
                this.cookieService.remove('applicationID');
                this.fillForm(this.accountcode);
            }
            //retrieve code from server
            if (this.cookieService.getObject('retrievecode')) {
                console.log('------>', this.cookieService.getObject('retrievecode'));
                this.downloadPDF = true;
                // this.real_resellerID =
                let reccode = <string>this.cookieService.getObject('retrievecode');
                this.accountcode = reccode;
                this.cookieService.remove('retrievecode');
                this.fillForm(this.accountcode);
            } else {
                check = false;
            }

            // this.accountcode ? this.fillForm(this.accountcode) : (check = true);

            // console.log(check, this.cookieService.getObject("form"));
            /*
            *if it a normal load, check the cookie
            */
            if (check) {
                if (this.cookieService.getObject('form')) {
                    if (this.cookieService.getObject('form') === 'true') {
                        // console.log("I have a cookies true");
                    }
                    // let formdata  = this.cookieService.getObject("form");
                    // this.retrieveService.patchForm(this.registerform, formdata);
                    this.retrievecookieService.patchForm(this.registerform);
                } else {
                    // else delete the cookies TODO:
                    // console.log("debugger  ");
                }
            }

            document.body.scrollTop = document.documentElement.scrollTop = 0;
        });

        // CHECK COOKIE
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    getCookie(key: string) {
        // console.log("cookie disable now");
        return this.cookieService.get(key);
    }

    // SECTION 1 : buildBusinessGroup
    buildBusinessGroup(): FormGroup {
        return this.fb.group({
            // left
            in_org_type: ['Registered Company', [Validators.required]], // registeredCompany
            in_customer_name: [
                '',
                [
                    Validators.required,
                    Validators.maxLength(rules.businessinfo_in_customer_name),
                    Validators.minLength(this.RULES.min_length)
                ]
            ], // businecustomerName
            in_entity_name: [
                '',
                [
                    Validators.required,
                    Validators.minLength(this.RULES.min_length),
                    Validators.maxLength(this.RULES.businessinfo_in_entity_name)
                ]
            ], // tradingEntityName
            in_trust_name: [
                '',
                [
                    // Validators.required,
                    Validators.minLength(this.RULES.min_length),
                    Validators.maxLength(this.RULES.businessinfo_in_trust_name)
                ]
            ], // trustName
            in_ABN: [
                '',
                [
                    Validators.required,
                    Validators.minLength(
                        this.web() > 0
                            ? this.RULES.businessinfo_in_NZBN
                            : this.RULES.businessinfo_in_ABN
                    ),
                    Validators.maxLength(
                        this.web() > 0
                            ? this.RULES.businessinfo_in_NZBN
                            : this.RULES.businessinfo_in_ABN
                    ),
                    patternValidator(/^[0-9]*[\w ]+$/)
                ]
            ], // ABN
            // An Australian Company Number (ACN) is a nine digit number allocated by
            // the Australian Securities
            in_ACN: [
                '',
                [
                    Validators.required,
                    Validators.minLength(this.RULES.businessinfo_in_ACN),
                    Validators.maxLength(this.RULES.businessinfo_in_ACN),
                    patternValidator(/^[0-9]*[\w ]+$/)
                ]
            ], // ACN

            // Requesting credit limit required
            in_date_business_started: [datefomart(), [reseller_dateValidation]], // dataBusinessStart[Validators.required]
            in_date_business_purchased: [datefomart(), [reseller_dateValidation]], // datapurchased
            in_bank_contact: [
                '',
                [
                    // Validators.required,
                    Validators.minLength(this.RULES.min_length),
                    Validators.maxLength(this.RULES.in_bank_contact)
                ]
            ], // bankingContact
            in_bank_address1: [
                '',
                [
                    Validators.required,
                    Validators.minLength(this.RULES.min_length),
                    Validators.maxLength(this.RULES.in_bank_address1)
                ]
            ], // bankDetail
            in_bank_address2: '', // bankDetail
            in_bank_address3: '', // bankDetail
            in_swift_address: [
                '',
                [
                    // disable swift address now
                    // Validators.required,
                    Validators.minLength(this.RULES.min_length),
                    Validators.maxLength(this.RULES.in_swift_address)
                ]
            ], // swiftAddress
            in_bank_account_name: [
                '',
                [
                    Validators.required,
                    Validators.minLength(this.RULES.min_length),
                    Validators.maxLength(this.RULES.in_bank_account_name)
                ]
            ], // accountName
            in_bsb: [
                '',
                [
                    Validators.required,
                    Validators.minLength(this.RULES.min_CARD_length),
                    Validators.maxLength(this.RULES.min_CARD_length),
                    patternValidator(/^[0-9]*$/)
                ]
            ], // BSB

            in_account_number: [
                '',
                [
                    Validators.required,
                    Validators.minLength(this.RULES.min_CARD_length),
                    Validators.maxLength(this.RULES.in_account_number),
                    patternValidator(/^[0-9]*$/)
                ]
            ], // accountNumber

            in_incorporation_date: [
                datefomart(), [reseller_dateValidation]],
            in_estimated_monthly_purch: [
                '',
                [
                    // Validators.required,
                    Validators.minLength(this.RULES.min_length),
                    Validators.maxLength(this.RULES.in_incorporation_place)
                ]
            ],
            in_incorporation_place: [
                '',
                [
                    // Validators.required,
                    Validators.minLength(this.RULES.min_length),
                    Validators.maxLength(this.RULES.in_incorporation_place)
                ]
            ],
            in_company_address1: [
                '',
                [
                    Validators.required,
                    Validators.minLength(this.RULES.min_length),
                    Validators.maxLength(this.RULES.in_company_address_1)
                ]
            ],
            in_company_address2: [
                '',
                [
                    Validators.required,
                    Validators.minLength(this.RULES.min_length),
                    Validators.maxLength(this.RULES.in_company_address_2)
                ]
            ],
            in_company_address3: [
                // will uncomment if the country needs to be added to the end of the city
                '', // this.tmpCompanyCity, // + " " + this.tmpCompanyCountry,
                [
                    Validators.required,
                    Validators.minLength(this.RULES.min_length),
                    Validators.maxLength(this.RULES.in_company_address_3)
                ]
            ],
            in_company_postcode: [
                '',
                [
                    Validators.required,
                    Validators.minLength(this.RULES.post_code_length),
                    Validators.maxLength(this.RULES.post_code_length),
                    patternValidator(/^[0-9]*$/)
                ]
            ],
            in_company_country: [
                this.web() === -1 ? 'Australia' : 'New Zealand', // this.tmpCompanyCountry,
                [Validators.required]
            ],
            in_company_suburb: [
                '',
                [
                    Validators.required,
                    Validators.minLength(this.RULES.min_length),
                    Validators.maxLength(this.RULES.in_company_suburb)
                ]
            ],
            in_company_street: [
                '',
                [
                    // Validators.required,
                    Validators.minLength(this.RULES.min_length),
                    Validators.maxLength(this.RULES.in_company_street)
                ]
            ],

            in_parent_company: [
                '',
                [
                    // Validators.required,
                    Validators.minLength(this.RULES.min_length),
                    Validators.maxLength(this.RULES.in_parent_company)
                ]
            ],
            in_delivery_address1: [
                '',
                [
                    Validators.minLength(this.RULES.min_length),
                    Validators.maxLength(this.RULES.in_delivery_address_1)
                ]
            ],
            in_delivery_address2: [
                '',
                [
                    Validators.minLength(this.RULES.min_length),
                    Validators.maxLength(this.RULES.in_delivery_address_2)
                ]
            ],
            in_delivery_address3: [    
                '',
                [
                    Validators.minLength(this.RULES.min_length),
                    Validators.maxLength(this.RULES.in_delivery_address_3)
                ]
            ],
            in_tenancy: 'Owned/Mortgage', // not set front
            in_time_at_address: ['', [Validators.required]],
            // TODO: EMAIL LENGTH NEED TO LONGER THAN THE FORMART IN THE EMAILED ME
            in_email: [
                '',
                [
                    Validators.required,
                    Validators.maxLength(this.RULES.in_email),
                    patternValidator(
                        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    )
                ]
            ],
            in_phonecode: ['', []],
            in_phone: [
                '',
                [
                    Validators.required,
                    Validators.minLength(this.RULES.min_phone),
                    Validators.maxLength(this.RULES.max_phone),
                    patternValidator(/^[0-9]*$/)
                    // patternValidator(/04[\d]{8}/g)
                    // now temp disable the phone validator
                ]
            ],

            // NEW VALUES FROM PREVIOUS NO PART SHIP DROP DOWN
            in_delivery_street: [
                '',
                [
                    Validators.minLength(this.RULES.min_length),
                    Validators.maxLength(this.RULES.in_delivery_street)
                ]
            ],
            in_delivery_suburb: [
                '',
                [
                    Validators.minLength(this.RULES.min_length),
                    Validators.maxLength(this.RULES.in_delivery_suburb)
                ]
            ],
            in_delivery_country: [''],
            in_delivery_postcode: [''],

            in_company_website_url: [
                '',
                [
                    Validators.minLength(this.RULES.min_length),
                    Validators.maxLength(this.RULES.max_url)
                ]
            ],
            // this field is removed from UI
            in_fax: ['', []],
            in_required_credit: 'C.B.D (<$10k per month)',

            // remove validator required
            // when customer choose not CBD then sett required
            in_RequestLimitCredit: ['0', [Validators.required]],

            // TODO: what do we fill on onlin-contact form
            in_online_contact: ['', [Validators.required]],
            in_admin_email: [
                '',
                [
                    Validators.required,
                    Validators.maxLength(this.RULES.in_email),
                    patternValidator(
                        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    )
                ]
            ],
            in_password: ['', [Validators.required]],
            in_part_ship: 'Part Ship' //not set yet
        });
    }

    //SECTION 2: business contacts


    buildBusinessContacts(): FormGroup {
        return this.fb.group({
            in_manager_name: ['', []],
            in_manager_email: ['', []],
            in_manager_phonecode: ['', []],
            in_manager_phone: ['', []],
            /**
             * The above elements are actuall removed from the UI
             */
            in_so_manager_name: [
                '',
                [
                    Validators.minLength(rules.min_length),
                    Validators.maxLength(rules.in_manager_name)
                ]
            ],
            in_so_manager_email: [
                '',
                [
                    patternValidator(
                        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    ),
                    Validators.minLength(rules.min_length),
                    Validators.maxLength(rules.in_manager_email)
                ]
            ],
            in_so_manager_phonecode: ['', []],
            in_so_manager_phone: [
                '',
                [
                    Validators.minLength(rules.min_phone),
                    Validators.maxLength(rules.max_phone),
                    patternValidator(/^[0-9]*$/)
                ]
            ],
            in_po_manager_name: [
                '',
                [
                    Validators.minLength(rules.min_length),
                    Validators.maxLength(rules.in_manager_name)
                ]
            ],
            in_po_manager_email: [
                '',
                [
                    patternValidator(
                        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    ),
                    Validators.minLength(rules.min_length),
                    Validators.maxLength(rules.in_manager_email)
                ]
            ],
            in_po_manager_phonecode: ['', []],
            in_po_manager_phone: [
                '',
                [
                    Validators.minLength(rules.min_phone),
                    Validators.maxLength(rules.max_phone),
                    patternValidator(/^[0-9]*$/)
                ]
            ],
            in_ap_manager_name: [
                '',
                [
                    Validators.minLength(rules.min_length),
                    Validators.maxLength(rules.in_manager_name)
                ]
            ],
            in_ap_manager_email: [
                '',
                [
                    patternValidator(
                        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    ),
                    Validators.minLength(rules.min_length),
                    Validators.maxLength(rules.in_manager_email)
                ]
            ],
            in_ap_manager_phonecode: [''],
            in_ap_manager_phone: [
                '',
                [
                    Validators.minLength(rules.min_phone),
                    Validators.maxLength(rules.max_phone),
                    patternValidator(/^[0-9]*$/)
                ]
            ],
            in_3p_manager_name: [''],
            in_3p_manager_email: [''],
            in_3p_manager_phone: ['']
        });
    }

    //SECTION 3: business owner information
    buildOwnerinfoItem() {
        return this.fb.group({
            in_director1_name: [
                '',
                [
                    Validators.required,
                    Validators.minLength(this.RULES.min_length),
                    Validators.maxLength(this.RULES.in_director1_name)
                ]
            ],
            in_director1_dob: [datefomart(), [reseller_dateValidation]],
            in_director1_phonecode: ['', []],
            in_director1_phone: [
                '',
                [
                    Validators.required,
                    Validators.minLength(this.RULES.min_phone),
                    Validators.maxLength(this.RULES.max_phone),
                    patternValidator(/^[0-9]*$/)
                ]
            ],
            in_director1_street: [
                '',
                [
                    Validators.required,
                    Validators.minLength(this.RULES.min_length),
                    Validators.maxLength(this.RULES.in_director1_street)
                ]
            ],
            in_director1_suburb: [
                '',
                [
                    Validators.required,
                    Validators.minLength(this.RULES.min_length),
                    Validators.maxLength(this.RULES.in_director1_suburb)
                ]
            ],
            in_director1_country: ['', [Validators.required]],

            in_director1_postcode: [
                '',
                [
                    Validators.required,
                    Validators.minLength(this.RULES.post_code_length),
                    Validators.maxLength(this.RULES.post_code_length),
                    patternValidator(/^[0-9]*$/)
                ]
            ],

            in_director1_address1: ['', []],
            in_director1_address2: [''],
            in_director1_address3: [''],
            in_director1_licence_no: [
                '',
                [
                    Validators.required,
                    Validators.maxLength(rules.director_licence_no),
                    patternValidator(/[a-zA-Z0-9]/)
                ]
            ]
        });
    }

    //SECTION 4: BUSINESS/TRADE REFERENCES
    buildBusinessRefItem() {
        return this.fb.group({
            in_supplier1_name: [
                '',
                [
                    Validators.required,
                    Validators.minLength(this.RULES.min_length),
                    Validators.maxLength(this.RULES.in_supplier1_name)
                ]
            ],
            in_supplier1_contact: [
                '',
                [
                    Validators.required,
                    Validators.minLength(this.RULES.min_length),
                    Validators.maxLength(this.RULES.in_supplier1_contact)
                ]
            ],
            in_supplier1_phonecode: ['', []],
            in_supplier1_phone: [
                '',
                [
                    Validators.required,
                    Validators.maxLength(this.RULES.max_phone),
                    Validators.minLength(this.RULES.min_phone),
                    patternValidator(/^[0-9]*$/)
                    // patternValidator(/^[0-9]*$/)
                    //disable phone number now
                    // patternValidator(/04[\d]{8}/g)
                ]
            ],
            in_supplier1_email: [
                '',
                [
                    Validators.required,
                    Validators.maxLength(this.RULES.in_email),
                    patternValidator(
                        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    )
                ]
            ]
        });
    }

    //FUNCTION AREA
    creditChangeEvent(event: any) {
        let selected = event.target.value;

        if (selected.indexOf('C.B.D') != -1) {
            console.log('coming in ');
            this.registerform
                .get('businessGroup')
                .get('in_RequestLimitCredit')
                .setValue('0');
        } else {
            this.registerform
                .get('businessGroup')
                .get('in_RequestLimitCredit')
                .setValue('');
        }
        this.registerform.updateValueAndValidity();
    }

    test() {
        // debugger;
        console.log(this.registerform.get('marketinfo').get('products'));
    }

    checkedValidator = (control: AbstractControl): { [key: string]: boolean } => {
        let group = control.value;

        for (let key in group) {
            if (group[key]) {
                return null;
            }
        }

        return { nockecked: true };
    };

    buildMarketinfo(): FormGroup {
        return this.fb.group({
            //check box side

            products: this.fb.group(
                {
                    in_principal_products_OEM: false,
                    in_principal_products_PC: false,
                    in_principal_products_Peripherals: false,
                    in_principal_products_Consumables: false,
                    in_principal_products_Networking: false,
                    in_principal_products_Infrastructure: false,
                    in_principal_products_Telecommunications: false,
                    in_principal_products_Software: false,
                    in_principal_products_Cloud: false,
                    in_principal_products_Solutions: false,
                    in_principal_products_Services: false,
                    in_principal_products_Other: false
                },
                { validator: this.checkedValidator }
            ),

            in_other_product_desc: '',
            markets: this.fb.group(
                {
                    in_markets_CORP: false,
                    in_markets_SME: false,
                    in_markets_CONS: false,
                    in_markets_OEM: false,
                    in_markets_GOV: false,
                    in_markets_EDU: false,
                    in_markets_WEB: false,
                    in_markets_FIN: false,
                    in_markets_TELE: false,
                    in_markets_OTH: false
                },
                { validator: this.checkedValidator }
            ),
            in_other_market_desc: '',

            in_focus_size: '250',
            in_percent_annuity_based: '25%'
        });
    }

    buildFinancialGroup(): FormGroup {
        return this.fb.group({
            //left
            in_current_year_turnover: ['', []],
            in_last_year_turnover: ['', []],
            in_capital: ['', []],
            in_no_of_shares: ['', []],

            //right
            in_current_assets: ['', []],
            in_current_liabilities: ['', []],
            in_encumberance_charges: ['', []],

            //radio box TODO NOT YET
            //in_bankrupcy
            in_bankrupcyYes: false,
            in_bankrupcyNo: true
        });
    }

    web() {
        // console.log(window.location.href.indexOf(".co.nz"));
        return window.location.href.indexOf('.co.nz');
        // return 1;
    }

    termsPopup: boolean = false;
    openTerms() {
        this.termsPopup = true;
    }

    buildDeclarationGroup(): FormGroup {
        return this.fb.group({
            in_declare_name: [
                '',
                [
                    Validators.required,
                    Validators.minLength(this.RULES.min_length),
                    Validators.maxLength(this.RULES.in_declare_name)
                ]
            ],

            in_declare_path: [
                ''
                // ,
                // [
                //   Validators.required,
                //   Validators.minLength(this.RULES.min_length),
                //   Validators.maxLength(this.RULES.in_declare_path)
                // ]
            ],
            in_declare_position: [
                '',
                [
                    Validators.required,
                    Validators.minLength(this.RULES.min_length),
                    Validators.maxLength(this.RULES.in_declare_position)
                ]
            ],

            //TODO date , [Validators.required]
            in_declare_date: [datefomart(), [reseller_dateValidation]]
        });
    }

    onChangeOrg(orgSelected: string) {
        //console.log("choose : ", orgSelected);
        if (orgSelected == 'Trust') {
            this.registerform
                .get('businessGroup')
                .get('in_trust_name')
                .setValidators([
                    Validators.required,
                    Validators.minLength(this.RULES.min_length),
                    Validators.maxLength(this.RULES.businessinfo_in_trust_name)
                ]);
        } else {
            this.registerform
                .get('businessGroup')
                .get('in_trust_name')
                .setValidators([
                    Validators.minLength(this.RULES.min_length),
                    Validators.maxLength(this.RULES.businessinfo_in_trust_name)
                ]);
        }
        this.registerform
            .get('businessGroup')
            .get('in_trust_name')
            .updateValueAndValidity();
    }
    buildGuaranteeGroup(): FormGroup {
        return this.fb.group({
            in_guarantor_name: [
                '',
                [
                    // Validators.required,
                    Validators.minLength(this.RULES.min_length),
                    Validators.maxLength(this.RULES.in_guarantor_name)
                ]
            ],
            in_guarantor_address1: [
                '',
                [
                    //Validators.required,
                    Validators.minLength(this.RULES.min_length),
                    Validators.maxLength(this.RULES.in_guarantor_address_1)
                ]
            ],
            // in_guarantor_address2: "",
            // in_guarantor_address3: "",

            //left
            in_guarantee_cust_name: [
                '',
                [
                    //Validators.required,
                    Validators.minLength(this.RULES.min_length),
                    Validators.maxLength(this.RULES.in_guarantee_cust_name)
                ]
            ],

            /**
             in_guarantor_name: '',
            in_guarantor_address1: '',
            in_guarantor_address2: '',
            one more time
            **/

            // in_guarantor_street: [
            //   "",
            //   [
            //     Validators.required,
            //     Validators.minLength(this.RULES.min_length),
            //     Validators.maxLength(this.RULES.in_guarantor_street)
            //   ]
            // ],
            in_guarantor_suburb: [
                '',
                [
                    //Validators.required,
                    Validators.minLength(this.RULES.min_length),
                    Validators.maxLength(this.RULES.in_guarantor_suburb)
                ]
            ],
            in_guarantor_postcode: [
                '',
                [
                    //Validators.required,
                    Validators.minLength(this.RULES.post_code_length),
                    Validators.maxLength(this.RULES.post_code_length),
                    patternValidator(/^[0-9]*$/)
                ]
            ],

            in_guarantor_country: [
                this.web() == -1 ? 'Australia' : 'New Zealand',
                []
            ],
            in_guarantor_sig_path: [
                ''
                // ,
                // [
                //   Validators.required,
                //   Validators.minLength(this.RULES.min_length),
                //   Validators.maxLength(this.RULES.in_guarantor_sig_path)
                // ]
            ],

            in_guarantor_date: [datefomart(), [reseller_dateValidation]],

            //right
            in_guarantor_abn: [
                '',
                [
                    //Validators.required,
                    Validators.minLength(
                        this.web() > 0
                            ? this.RULES.in_guarantor_nzbn
                            : this.RULES.in_guarantor_abn
                    ),
                    Validators.maxLength(
                        this.web() > 0
                            ? this.RULES.in_guarantor_nzbn
                            : this.RULES.in_guarantor_abn
                    ),
                    patternValidator(/^[0-9]*$/)
                ]
            ],
            in_witness_name: [
                '',
                [
                    //Validators.required,
                    Validators.minLength(this.RULES.min_length),
                    Validators.maxLength(this.RULES.in_witness_name)
                ]
            ],
            in_witness_address1: [
                '',
                [
                    //Validators.required,
                    Validators.minLength(this.RULES.min_length),
                    Validators.maxLength(this.RULES.in_witness_address_1)
                ]
            ],

            in_witness_suburb: [
                '',
                [
                    //Validators.required,
                    Validators.minLength(this.RULES.min_length),
                    Validators.maxLength(this.RULES.in_witness_suburb)
                ]
            ],
            in_witness_country: [
                this.web() == -1 ? 'Australia' : 'New Zealand',
                [
                    //Validators.required
                ]
            ],
            in_witness_postcode: [
                '',
                [
                    //Validators.required,
                    Validators.minLength(this.RULES.post_code_length),
                    Validators.maxLength(this.RULES.post_code_length),
                    patternValidator(/^[0-9]*$/)
                ]
            ],

            in_witness_sig_path: [''],
            in_witness_date: [datefomart(), [reseller_dateValidation]]
        });
    }

    partShip: string = 'Part Ship';
    buildDeliverItems() {
        return this.fb.group({
            in_delivery_street: [''],
            in_delivery_suburb: [''],
            in_delivery_country: [''],
            in_delivery_postcode: ['']
        });
    }

    addValidatorOnDelivery() { }

    addValidators(otherProductCheck: boolean, otherMarketCheck: boolean) {
        if (otherProductCheck) {
            this.registerform
                .get('marketinfo.in_other_product_desc')
                .setValidators([Validators.required]);
        }
        if (otherMarketCheck) {
            this.registerform
                .get('marketinfo.in_other_market_desc')
                .setValidators([Validators.required]);
        }
        this.registerform.get('marketinfo.in_other_product_desc')
            .updateValueAndValidity;
        this.registerform.get('marketinfo.in_other_market_desc')
            .updateValueAndValidity;
        this.registerform.get('marketinfo').updateValueAndValidity;
    }

    otherProductCheck: boolean = false;
    onChangeOther(event) {
        let check = this.registerform.get(
            'marketinfo.products.in_principal_products_Other'
        ).value;

        if (check) {
            this.otherProductCheck = true;
            this.registerform
                .get('marketinfo.in_other_product_desc')
                .setValidators([Validators.required]);
            this.registerform.get('marketinfo.in_other_product_desc')
                .updateValueAndValidity;
            this.registerform.get('marketinfo').updateValueAndValidity;
        } else {
            this.otherProductCheck = false;
            this.registerform
                .get('marketinfo.in_other_product_desc')
                .clearValidators();
            this.registerform.get('marketinfo.in_other_product_desc')
                .updateValueAndValidity;
            this.registerform.get('marketinfo').updateValueAndValidity;
        }
    }

    onChangeMarketOther(event) {
        let check = this.registerform.get('marketinfo.markets.in_markets_OTH')
            .value;

        if (check) {
            this.otherMarketCheck = true;
            this.registerform
                .get('marketinfo.in_other_market_desc')
                .setValidators([Validators.required]);
            this.registerform.get('marketinfo.in_other_market_desc')
                .updateValueAndValidity;
            this.registerform.get('marketinfo').updateValueAndValidity;
        } else {
            this.otherMarketCheck = false;
            this.registerform
                .get('marketinfo.in_other_market_desc')
                .setValidators([Validators.required]);
            this.registerform.get('marketinfo.in_other_market_desc')
                .updateValueAndValidity;
            this.registerform.get('marketinfo').updateValueAndValidity;
        }
    }


    save_registerform() {
        console.log('save register form');
        // background blur
        this.registerService.submitform(this.registerform);
    }

    save_Cookie() {
        // console.log("first save form information into the cookies; cookie disable");

        this.cookieService.putObject('form', <REGISTER>this.registerform.value);
    }

    /**
     * form action databinding
     */

    receiveMailAction() { }

    financialCheckInActionYes(event: Event) {
        if (this.checkbox_in_bankrupcyYes) {
            this.checkbox_in_bankrupcyYes = false;
            this.checkbox_in_bankrupcyNo = true;
        } else {
            this.checkbox_in_bankrupcyYes = true;
            this.checkbox_in_bankrupcyNo = false;
        }

        event.stopPropagation();
    }

    financialCheckInActionNo(event: Event) {
        if (this.checkbox_in_bankrupcyNo) {
            this.checkbox_in_bankrupcyNo = false;
            this.checkbox_in_bankrupcyYes = true;
        } else {
            this.checkbox_in_bankrupcyNo = true;
            this.checkbox_in_bankrupcyYes = false;
        }

        event.stopPropagation();
    }

    privacyCheckInActionYes(event: Event) {
        if (this.checkbox_receiveMail_yes) {
            this.checkbox_receiveMail_yes = false;
            this.checkbox_receiveMail_no = true;
            // this.registerform.get('privacyGroup.in_mailing_email')
            this.registerform.get('privacyGroup.in_mailing_email').reset();
            this.registerform.get('privacyGroup.in_mailing_email').clearValidators();
            // this.registerform
            //   .get('privacyGroup.in_mailing_email')
            //   .setErrors({ required: null });
        } else {
            this.checkbox_receiveMail_yes = true;
            this.checkbox_receiveMail_no = false;
            this.registerform.get('privacyGroup.in_mailing_email').reset();
            this.registerform
                .get('privacyGroup.in_mailing_email')
                .setValidators([
                    Validators.required,
                    Validators.maxLength(this.RULES.in_email),
                    patternValidator(
                        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    )
                ]);
        }
        this.registerform
            .get('privacyGroup.in_mailing_email')
            .updateValueAndValidity();
        this.cdRef.detectChanges();
        event.stopPropagation();
    }

    privacyCheckInActionNo(event: Event) {
        if (this.checkbox_receiveMail_no) {
            this.checkbox_receiveMail_no = false;
            this.checkbox_receiveMail_yes = true;
            this.registerform
                .get('privacyGroup.in_mailing_email')
                .setValidators([
                    Validators.required,
                    Validators.maxLength(this.RULES.in_email),
                    patternValidator(
                        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    )
                ]);
        } else {
            this.checkbox_receiveMail_no = true;
            this.checkbox_receiveMail_yes = false;

            this.registerform.get('privacyGroup.in_mailing_email').reset();
            // this.registerform
            //   .get('privacyGroup.in_mailing_email')
            //   .setErrors({ required: false });
            this.registerform.get('privacyGroup.in_mailing_email').clearValidators();
        }
        this.registerform
            .get('privacyGroup.in_mailing_email')
            .updateValueAndValidity();

        this.cdRef.detectChanges();
        event.stopPropagation();
    }

    onChangeDeliverMethod(event: any) {
        console.log(event.target.value);
        // if (
        //   this.deliverMethodArray.length < 1 &&
        //   event.target.value == 'Part Ship'
        // ) {
        //   this.deliverMethodArray.push(this.buildDeliverItems());
        //   this.deliverMethodArray.updateValueAndValidity();
        //   this.registerform.updateValueAndValidity();
        //   this.cdRef.detectChanges();
        // } else {
        //   this.registerform.controls['deliverMethodArray'] = this.fb.array([]);
        //   this.deliverMethodArray.updateValueAndValidity();
        //   this.registerform.updateValueAndValidity();
        //   this.cdRef.detectChanges();
        // }
    }

    /**
     * control with the reactive form, dynamic
     */

    //dumplicate forms
    addOwnerinfoItem() {
        if (this.ownerinfoArray.length >= 3) {
            return;
        }
        this.ownerinfoArray.push(this.buildOwnerinfoItem());
        //
    }

    //delete forms
    deleteOwnerinfoItem() {
        if (this.ownerinfoArray.length > 1) {
            this.ownerinfoArray.controls.pop();
            this.ownerinfoArray.removeAt(this.ownerinfoArray.length);
        } else {
        }
    }

    addbusinessrefItem() {
        // console.log(this.create);
        // this.create = "create";
        this.businessRefArray.push(this.buildBusinessRefItem());
    }

    deletebusinessrefItem() {
        // console.log("--deleter",this.businessRefArray.length)
        if (this.businessRefArray.length > 1) {
            this.businessRefArray.controls.pop();
            this.businessRefArray.removeAt(this.businessRefArray.length);
        } else {
        }
    }

    /**
     * support interface array so html can get it
     */

    get deliverMethodArray(): FormArray {
        return <FormArray>this.registerform.get('deliverMethodArray');
    }

    get ownerinfoArray(): FormArray {
        return <FormArray>this.registerform.get('ownerinfoArray');
    }

    get businessRefArray(): FormArray {
        return <FormArray>this.registerform.get('businessRefArray');
    }

    // businessRefArray

    /**
     * Fill the form all the form information
     */
    fillForm(accountcode?: string) {
        //HTTP call from the backend
        //console.log("calling the backend to get the data , fill form");
        // http://localhost:52478/api/values
        //this.registerform,
        this.retrieveService.fillForm(accountcode).subscribe(
            resp => {
                let formdata: OUTTYPE = resp;

                if (formdata.out_error) {
                    this.error = true;
                    this.errorTEXT = formdata.out_error;
                } else {
                    //console.log(formdata);
                    if (formdata.out_part_ship == 'Y') {
                        this.deliverMethodArray.push(this.buildDeliverItems());
                    }

                    this.retrieveService.patchForm(this.registerform, formdata);
                    this.downloadPDF = true;
                    this.real_resellerID = formdata.out_reseller_accountcode;

                    // console.log(
                    //   'check value before : ',
                    //   this.registerform.get('marketinfo'),
                    //   this.registerform.get('marketinfo.markets.in_markets_OTH').value
                    // );
                    this.otherMarketCheck = this.registerform.get(
                        'marketinfo.markets.in_markets_OTH'
                    ).value;
                    this.otherProductCheck = this.registerform.get(
                        'marketinfo.products.in_principal_products_Other'
                    ).value;

                    this.addValidators(this.otherMarketCheck, this.otherProductCheck);
                }
            },
            error => {
                //console.log("has error: ", error);
                this.error = true;
                this.errorTEXT = 'Could not connect to the server';
            }
        );
    }

    public error: boolean = false;
    public errorTEXT: string = '';
    /**
     *
     */

    submit() {
        // console.log(this.registerform.get('declarationGroup.in_declare_date'))
        this.scrollTo();

        this.sub_click = true;

        // console.log("this.sub_click....",this.sub_click,"touch: .....", this.registerform.touched);
        // TODO: 12:19pm the below code show moved intot the if condifitons

        this.registerform.get('privacyGroup.in_mailing_email').clearValidators();

        if (this.registerform.valid) {
            /**
             * all form data are correct
             */

            this.error = false;
            this.submitPopUp = !this.submitPopUp;
        } else {
            this.error = true;
            // setTimeout(function() {
            //   window.scrollTo(0, document.body.scrollHeight);
            // }, 10);
            document.body.style.overflow = 'hidden';
            if (this.registerform.touched) {
                this.errorTEXT = 'Fix the error fields in the form.';
            } else {
                this.errorTEXT = 'Fix the error fields in the form.';
            }
        }
    }

    /**
     * close the rooro dialog
     */

    closeErrorDialog() {
        this.error = false;
        document.body.style.overflow = 'auto';
    }

    scrollTo() {
        console.log('business group valid: ', this.registerform.get('businessGroup').valid);
        // console.log('business group valid: ', this.registerform.get('businessGroup').valid);
        if (!this.registerform.get('businessGroup').valid) {
            $('html, body').animate(
                {
                    scrollTop: $('#businessGroup').offset().top
                },
                1000
            );
        } else if (!this.registerform.get('businesscontacts').valid) {
            $('html, body').animate(
                {
                    scrollTop: $('#CONTACTS_ACHOR_FORM').offset().top
                },
                1000
            );
        } else if (!this.registerform.get('ownerinfoArray').valid) {
            $('html, body').animate(
                {
                    scrollTop: $('#ownerinfoArray').offset().top
                },
                1000
            );
        } else if (!this.registerform.get('businessRefArray').valid) {
            $('html, body').animate(
                {
                    scrollTop: $('#businessRefArray').offset().top
                },
                1000
            );
        } else if (!this.registerform.get('financialGroup').valid) {
            $('html, body').animate(
                {
                    scrollTop: $('#FINANCIALDETAIL_ACHOR_FORM').offset().top
                },
                1000
            );
        } else if (!this.registerform.get('privacyGroup').valid) {
            $('html, body').animate(
                {
                    scrollTop: $('#PRIVACY_ACHOR_FORM').offset().top
                },
                1000
            );
        } else if (!this.registerform.get('declarationGroup').valid) {
            $('html, body').animate(
                {
                    scrollTop: $('#declarationGroup').offset().top
                },
                1000
            );
        } else if (!this.registerform.get('marketinfo').valid) {
            $('html, body').animate(
                {
                    scrollTop: $('#MARKETiNFOR_ACHOR').offset().top
                },
                1000
            );
        }
    }

    /**
     *
     */
    setSavePDF(event: any) {
        this.real_resellerID = event;
        this.downloadPDF = true;
    }

    /**
     *
     */
    saveToPDF() {
        this.pdfService.saveToPDF(this.registerform, this.real_resellerID);
    }

    /**
     * scroll
     * this is when user click a tag and direct them to the location in the page
     */

    scroll(location: string) {
        // $("html, body").animate(
        //   {
        //     scrollTop: $(location).offset().top
        //   },
        //   1000
        // );
    }

    onScroll() {
        // get the current position of scroll
        const scrollPos = $(document).scrollTop();
        // let scrollArray = ["#MARKETiNFOR_ACHOR"];

        // let item = scrollArray[0]
        // // console.log(scrollPos, ":  "+scrollArray[0] +":" + $('#MARKETiNFOR_ACHOR').scrollTop());

        // // console.log($(scrollArray[0]).scrollTop().position().top);
        // if($(scrollArray[0]).position().top<=scrollPos){
        //   console.log('com in side ');
        //   // $(scrollArray[0]).addClass("active");
        // }
        $('#table-of-contents a').each(function () {
            const currentLink = $(this);

            const triggerElement = $(currentLink.attr('href'));
            // console.log(' now : ', currentLink.height(), triggerElement.height());

            // debugger;
            if (
                triggerElement.position().top - 54 <= scrollPos &&
                triggerElement.position().top +
                $('#' + currentLink.attr('href').split('#')[1] + '_FORM').height() >
                scrollPos
            ) {
                $('#table-of-contents a').removeClass('active');
                currentLink.addClass('active');
            } else {
                currentLink.removeClass('active');
            }
        });
        //     var currLink = $(this);

        //     // var refElement = $(currLink)[0].innerText;
        //     let refElement = $('#'+$(currLink).innerText);
        //     console.log('refElement : ',refElement, $(currLink).innerText);
        //     debugger;
        //     if (refElement.position().top <= scrollPos && refElement.position().top + refElement.height() > scrollPos) {
        //         $('#menu-center ul li a').removeClass("active");
        //         currLink.addClass("active");
        //     }
        //     else{
        //         currLink.removeClass("active");
        //     }
        // });
    }

    /**
     * TODO:
     */
    dynnamicGenerateDirector() { }

    /**
     *  below is the layout set
     */

    setSubmitPopUp(event: boolean) {
        // console.log("get the submit click event , ", event);
        this.submitPopUp = event;
    }

    setsavePopUp(event: boolean) {
        // console.log("get the save click event , ", event);
        this.savePopUp = event;
    }

    setRestrevetPopUp(event: boolean) {
        // console.log("get the save click event , ", event);
        this.retrievePopUp = event;
    }

    closeIfSubmitout(event) {
        // console.log("dsadsa");
        this.submitPopUp = !this.submitPopUp;
        document.body.style.overflow = 'auto';
        event.preventDefault();
        event.stopPropagation();
    }

    closeIfTermsout(event) {
        // console.log("dsadsa");
        this.termsPopup = !this.termsPopup;
        document.body.style.overflow = 'auto';
        event.preventDefault();
        event.stopPropagation();
    }

    closeIfPopUpout(event) {
        // console.log("dsadsa");
        this.savePopUp = !this.savePopUp;
        document.body.style.overflow = 'auto';
        event.preventDefault();
        event.stopPropagation();
    }

    closeIfRetrieveout(event) {
        // console.log("dsadsa");
        this.retrievePopUp = !this.retrievePopUp;
        document.body.style.overflow = 'auto';
        event.preventDefault();
        event.stopPropagation();
    }

    emptyForm() {
        // this.registerform.markAsPristine();
        // this.registerform.markAsUntouched();
        // this.registerform.updateValueAndValidity();
        // console.log(this.registerform.valid);
        // TODO:  now is only reload page, need to find a way to
        //  reset page
        // if (!this.registerform.valid) {
        //   location.reload();
        // } else {
        // }

        // this.registerform.reset();
        // TODO: need to reconsider here
        location.reload();
    }
}



// WEBPACK FOOTER //
// ./src/app/register/register.component.ts